import { SwrPaginationWithSortInterface } from 'shared/types/pagination-interface'

export interface GetPaginationQueryStringProps extends SwrPaginationWithSortInterface {
  style?: 'brackets' | 'dots'
}

export const getPaginationQueryString = ({
  limit,
  pagination,
  sort,
  style = 'brackets',
}: GetPaginationQueryStringProps) => {
  const queries = []

  queries.push(
    style === 'brackets'
      ? `pagination[order]=${pagination.order}`
      : `pagination.order=${pagination.order}`,
  )

  if (pagination.startFromId !== undefined) {
    queries.push(
      style === 'brackets'
        ? `pagination[startFrom]=${pagination.startFromId}`
        : `pagination.startFrom=${pagination.startFromId}`,
    )
  }

  if (limit !== undefined) {
    queries.push(style === 'brackets' ? `pagination[limit]=${limit}` : `pagination.limit=${limit}`)
  }

  if (sort?.sortDirection) {
    queries.push(
      style === 'brackets'
        ? `pagination[sortDirection]=${sort.sortDirection}`
        : `pagination.sortDirection=${sort.sortDirection}`,
    )
  }

  if (sort?.sortColumn) {
    queries.push(
      style === 'brackets'
        ? `pagination[sortColumn]=${sort.sortColumn}`
        : `pagination.sortColumn=${sort.sortColumn}`,
    )
  }

  return queries.join('&')
}
